import { twMerge } from "tailwind-merge";

type AvatarProps = {
  name?: string | null;
  email?: string | null;
  photoURL?: string | null;
  className?: string;
};

function initialsOf(name?: string | null, email?: string | null) {
  const source = name || email || "?";
  const parts = source.trim().split(/[\s@.]+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("");
}

function Avatar({ name, email, photoURL, className }: AvatarProps) {
  if (photoURL) {
    return (
      <img
        src={photoURL}
        alt={name || "user"}
        className={twMerge("w-9 h-9 rounded-full object-cover", className)}
      />
    );
  }
  return (
    <div
      className={twMerge(
        "w-9 h-9 rounded-full bg-brand-gradient text-white text-xs font-bold flex items-center justify-center select-none",
        className
      )}
    >
      {initialsOf(name, email)}
    </div>
  );
}

export default Avatar;
